module.exports = __webpack_public_path__ + "img/vip-diamond-line.3974f498.svg";